import styled from "styled-components";

export const Action = styled.div`
  display: flex;
  justify-content: flex-end;
`;
